module.exports = __webpack_public_path__ + "static/media/abramov.4cb1eadc.jpg";